import React from "react";
import "./Loader.scss";

const Loader = () => {
  return (
    <>
      <div className="mx-auto mt-5 loader" />
    </>
  );
};

export default Loader;
